export default "__VITE_PUBLIC_ASSET__26514664__"